import { gql } from '../../../__generated__/graphql/catalog'

export const DEPRECATED_CLAIM_GIFT_PRODUCT_GROUP = gql(`
  query ZidiProductGroup(
    $handle: String!
    $collectionHandle: String
    $collectionScope: ProductGroupColorSelector
    $b2bCollectionHandle: String
    $withB2BColors: Boolean!
  ) {
    productGroup(
      handle: $handle
      collectionHandle: $collectionHandle
    ) {
      id
      category
      rawCategory
      genderCategory
      b2bColorGroups: colorGroups(collectionHandle: $b2bCollectionHandle, onlyScoped: true) @include(if: $withB2BColors) {
        ...ColorGroup
      }
      colorGroups(
        selector: $collectionScope
      ) {
        ...ColorGroup
      }
      description
      embroiderable
      iconBadge
      iconBadgePlacement
      priceRange {
        min
        max
      }
      productsForAvailability: products {
        id
        __typename
        availableSizes
        colorInfo {
          rawName
        }
        fit
        rawFit
        swPromoEligible
        priceRange
        defaultVariant {
          price
          discountPrice
        }
      }
      handle
      rtfFeatures
      title
      sizes
      # Only used to tell whether the product group has a chart at all. The chart itself is
      # fetched by the size chart modal, on open.
      sizeChartCG {
        name
      }
      style
      fits
      rawFits
    }
  }
`)
